import { useState, useEffect } from 'react';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';
import api from '../api';

const chartData = [
  { month: 'Jan', users: 30, threats: 20 },
  { month: 'Feb', users: 45, threats: 35 },
  { month: 'Mar', users: 60, threats: 50 },
  { month: 'Apr', users: 55, threats: 40 },
  { month: 'May', users: 75, threats: 60 },
  { month: 'Jun', users: 65, threats: 45 },
  { month: 'Jul', users: 80, threats: 70 },
  { month: 'Aug', users: 90, threats: 55 },
];

const activities = [
  { text: 'New user registered', time: '2 min ago', color: '#2563eb' },
  { text: 'Threat detected on device', time: '15 min ago', color: '#dc2626' },
  { text: 'Firewall rule updated', time: '1 hr ago', color: '#d97706' },
  { text: 'Application added', time: '3 hr ago', color: '#16a34a' },
  { text: 'Settings changed', time: '5 hr ago', color: '#7c3aed' },
  { text: 'New user registered', time: '8 hr ago', color: '#2563eb' },
];

export default function DashboardHome() {
  const [stats, setStats] = useState({ totalUsers: '—', activatedKeys: '—', deactivatedKeys: '—', totalKeys: '—' });

  useEffect(() => {
    api.get('/admin/dashboard/stats')
      .then(({ data }) => setStats(data.data))
      .catch(() => {});
  }, []);

  return (
    <>
      <div className="stats-grid">
        <StatCard value={stats.totalUsers}      label="Total Users"         icon="👥" color="#2563eb" bg="#dbeafe" />
        <StatCard value={stats.totalKeys}       label="Total License Keys"  icon="🔑" color="#7c3aed" bg="#ede9fe" />
        <StatCard value={stats.activatedKeys}   label="Activated Keys"      icon="✅" color="#16a34a" bg="#dcfce7" />
        <StatCard value={stats.deactivatedKeys} label="Deactivated Keys"    icon="🔒" color="#d97706" bg="#fef3c7" />
      </div>

      <div className="charts-row">
        {/* <div className="chart-card">
          <div className="card-header">
            <span className="card-title">Activity Overview</span>
          </div>
          <ResponsiveContainer width="100%" height={260}>
            <AreaChart data={chartData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
              <defs>
                <linearGradient id="gUsers" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#2563eb" stopOpacity={0.3} />
                  <stop offset="95%" stopColor="#2563eb" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="gThreats" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#16a34a" stopOpacity={0.3} />
                  <stop offset="95%" stopColor="#16a34a" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="month" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip />
              <Legend />
              <Area type="monotone" dataKey="users"   stroke="#2563eb" fill="url(#gUsers)"   strokeWidth={2} />
              <Area type="monotone" dataKey="threats" stroke="#16a34a" fill="url(#gThreats)" strokeWidth={2} />
            </AreaChart>
          </ResponsiveContainer>
        </div>

        <div className="activity-card">
          <div className="card-header">
            <span className="card-title">Recent Activity</span>
          </div>
          {activities.map((item, i) => (
            <div key={i} className="activity-item">
              <div className="activity-dot" style={{ background: item.color }} />
              <div className="activity-text">
                <span className="activity-label">{item.text}</span>
                <span className="activity-time">{item.time}</span>
              </div>
            </div>
          ))}
        </div> */}
      </div>

      
    </>
  );
}

function StatCard({ value, label, icon, color, bg }) {
  return (
    <div className="stat-card" style={{ borderTop: `4px solid ${color}` }}>
      <div className="stat-left">
        <div className="stat-value">{value}</div>
        <div className="stat-label">{label}</div>
      </div>
      <div className="stat-icon" style={{ background: bg, color }}>{icon}</div>
    </div>
  );
}
